import CityPageTemplate from "../city-template/CityPageTemplate";
import { vallejoConfig } from "./data";

export default function VallejoPage() {
  return <CityPageTemplate config={vallejoConfig} />;
}